import * as i0 from '@angular/core';
import { InjectionToken, inject, Injectable, APP_INITIALIZER, makeEnvironmentProviders } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PlatformService } from '@noda-lib/utils/services';
import { ajax } from 'rxjs/ajax';
import { tap, map } from 'rxjs/operators';
const INITIALIZE_HANDLER = new InjectionToken('INITIALIZE_HANDLER');
let InitializeService = /*#__PURE__*/(() => {
  class InitializeService {
    constructor() {
      this.initializeHandler = inject(INITIALIZE_HANDLER, {
        optional: true
      });
      this.httpClient = inject(HttpClient);
      this.platform = inject(PlatformService);
    }
    initialize(environment) {
      const url = `${environment.CONFIG_ROOT}?t=${Date.now()}`;
      if (this.platform.isServer()) {
        return this.httpClient.get(url).pipe(tap(env => {
          Object.assign(environment, env);
          if (this.initializeHandler) this.initializeHandler(environment);
        }), map(Boolean));
      } else {
        return ajax.getJSON(url).pipe(tap(env => {
          Object.assign(environment, env);
          if (this.initializeHandler) this.initializeHandler(environment);
        }), map(Boolean));
      }
    }
    static {
      this.ɵfac = function InitializeService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InitializeService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: InitializeService,
        factory: InitializeService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return InitializeService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/naming-convention */
function provideUtilsInitializer(environment, ...features) {
  const providers = Array.from(features).concat([InitializeService, {
    provide: APP_INITIALIZER,
    useFactory() {
      const initializeService = inject(InitializeService);
      return () => initializeService.initialize(environment);
    },
    multi: true
  }]);
  return makeEnvironmentProviders(providers);
}
function withInitializeHandler(handler) {
  const provider = {
    provide: INITIALIZE_HANDLER,
    useFactory: handler
  };
  return provider;
}

/**
 * Generated bundle index. Do not edit.
 */

export { provideUtilsInitializer, withInitializeHandler };
